import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { ConfigService } from 'src/app/services/core/config/config.service';
import { UserService } from 'src/app/services/core/users/user.service';
import { sweetAlert } from 'src/app/utils/swal';
import { onTimeChange } from 'src/app/utils/utils.common';
@UntilDestroy()
@Component({
  selector: 'app-company-configuration',
  templateUrl: './company-configuration.component.html',
  styleUrls: ['./company-configuration.component.css']
})
export class CompanyConfigurationComponent implements OnInit {
  @Input() companyId: any
  cofigurationForm!: FormGroup
  approvalForm!: FormGroup;
  configVerificationForm!: FormGroup;
  companyData: any;
  submitted = false;
  users: any[] = [];
  configId:any

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private configService: ConfigService,
    private userService: UserService,
    private sharedDataService: SharedDataService
  ) { }


  ngOnInit() {
    this.cofigurationForm = this.fb.group({
      reference: [''],
      generalUrl: [''],
      tripUrl: [''],
      vehicleUrl: [''],
      driverUrl: [''],
    });


    this.approvalForm = this.fb.group({
      isApproved: [false, Validators.required],
      approvedDate: ['', Validators.required],
      user: ['', Validators.required],
    })


    this.configVerificationForm = this.fb.group({
      reference: [false],
      generalUrl: [false],
      tripUrl: [false],
      vehicleUrl: [false],
      driverUrl: [false],
    })
    this.getUser();
    this.getConfigurationbyId();
  }

  getUser() {
    this.sharedDataService
    .getUser()
    .pipe(untilDestroyed(this)).subscribe(user => {
      if (user) {
        this.approvalForm.patchValue({
          user: user.id
        });
      }
    });
  }


  setControls(groupName: string, controlName: string, value: any) {
    const fullPath = groupName ? `${groupName}.${controlName}` : controlName;
    const control = this.configVerificationForm.get(fullPath);
    if (control) {
      control.setValue(value);
      control.markAsTouched();
    }
  }

  getConfigurationbyId() {
    this.configService.getConfigByCompanyWise(this.companyId)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data) {
          this.configId = data._id
          this.companyData = data
          this.cofigurationForm.patchValue({
            ...data
          });
          this.configVerificationForm.patchValue({
            ...data.validationFlags
          });
        }
      });
  }

  checkNonValidFields() {
    const nonValidFields: string[] = [];

    const traverse = (obj: { [x: string]: any; }, path = "") => {
      for (const key in obj) {
        const value = obj[key];
        const currentPath = path ? `${path}.${key}` : key;

        if (!value) {
          nonValidFields.push(currentPath);
        }

        if (typeof value === "object" && value !== null) {
          traverse(value, currentPath);
        }
      }
    };

    traverse(this.companyData?.validationFlags);
    traverse(this.configVerificationForm.value);
    return nonValidFields;
  }

  patchValuesToForm(data: any) {

    this.cofigurationForm.patchValue({
      ...data,
    });

    this.approvalForm.patchValue(data);
    this.configVerificationForm.patchValue({
      ...data.validationFlags,
    });
  }

  onApproval() {
    this.submitted = true
    const isCurrentlyApproved = this.companyData?.isApproved;
    if (this.checkNonValidFields().length && !isCurrentlyApproved) {
      sweetAlert('Alert', `Some fields are missing.`, 'warning', 'OK')
      return;
    }

    const newApprovalState = !isCurrentlyApproved;
    if (this.approvalForm.invalid) {
      return;
    }
    this.approvalForm.patchValue({
      isApproved: newApprovalState
    })
    const payload = this.approvalForm.value;
    this.configService.approvedCompany(this.configId, payload).pipe(untilDestroyed(this)).subscribe((data) => {
      if (data) {
        this.companyData = data;
        this.patchValuesToForm(data)
      }
    })
  }

  getInvalidFields(): string[] {
    const formValues = this.configVerificationForm.value;
    const labels: string[] = [];
    this.traverseForm(formValues, this.configVerificationForm, labels);
    return labels;
  }

traverseForm(values: any, formGroup: FormGroup | AbstractControl, labels: string[], prefix: string = ''): void {
  if (formGroup instanceof FormGroup) {
    Object.keys(values).forEach(key => {
      const value = values[key];
      const control = formGroup.get(key);

      if (value !== null && typeof value === 'object') {
        // Recurse for nested groups
        this.traverseForm(value, control as FormGroup, labels, prefix + key + '.');
      } else if (value === false) {
        // Push label/key for invalid fields
        labels.push(prefix + key);
      }
    });
  }
}

  sendInvalidFieldsViaEmail(): void {
    const invalidFields = this.getInvalidFields();
    if (invalidFields.length > 0) {
      const payload = invalidFields;
      this.configService.informationViaEmail(this.configId, invalidFields).pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data) {
        }
      })
    }
  }

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }

  onSave() {

    if (this.configVerificationForm.invalid) {
      return;
    }
    const payload = this.configVerificationForm.value;
    this.configService.verifyCompany(this.configId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.companyData = data;
        this.patchValuesToForm(data)
      }
    })


  }

  get approveForm() {
    return this.approvalForm.controls;
  }
}
